import getStore from 'src/modules/store';
import {applyDivisionIdPolicyToPayload} from './divisionIdFormPolicy';

/**
 * Aplica la misma política que los formularios (`applyDivisionIdPolicyToPayload`) a un objeto
 * `data` que va al API. Útil en interceptor de creaciones POST cuando el formulario no pasó por el helper.
 */
export function applyTenantDivisionPolicyToApiPayload(payload: Record<string, any>): void {
  try {
    const ctx = getStore()?.getState?.()?.auth?.tenantAccessContext;
    applyDivisionIdPolicyToPayload(payload, ctx);
  } catch {
    /* store aún no inicializado */
  }
}
